import styled, { css } from 'styled-components'
import { TableCell, TableRow } from '@material-ui/core'
import { RowVariant } from './index'

export const Wrapper = styled.div`
  width: 100%;

  .MuiTableContainer-root {
    border-radius: ${({ theme }) => theme.ds.typography.border.radius.medium};
    overflow: hidden;
    box-shadow: ${({ theme }) => theme.ds.shadows.normal};
  }

  .MuiTable-root {
    border-collapse: separate;
    border-spacing: 0;
  }
`

export const StyledHeaderCell = styled(TableCell)`
  && {
    background-color: ${({ theme }) => theme.ds.colors.primary50};
    color: ${({ theme }) => theme.ds.colors.primary700};
    font-size: ${({ theme }) => theme.ds.typography.size.xxxsmall};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    padding: 1rem;

    &.centered {
      text-align: center;
    }
  }
`

export const StyledSectionCell = styled(TableCell)`
  && {
    background-color: ${({ theme }) => theme.ds.colors.white};
    color: ${({ theme }) => theme.ds.colors.textSecondary};
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    font-weight: ${({ theme }) => theme.ds.typography.weight.black};
    padding: 0.75rem 1rem;
  }
`

export const StyledBodyRow = styled(TableRow)<{
  $isEven?: boolean
  $variant?: RowVariant
  $disableHoverColorChange?: boolean
}>`
  && {
    height: 4rem;

    ${({ $isEven, $variant, $disableHoverColorChange, theme }) => {
      if ($variant === 'danger') {
        return css`
          background-color: ${theme.ds.colors.danger50};

          ${!$disableHoverColorChange &&
          css`
            &:hover {
              background-color: ${theme.ds.colors.danger100};
            }
          `}
        `
      }

      return css`
        background-color: ${$isEven
          ? theme.ds.colors.white
          : theme.ds.colors.neutral50};

        ${!$disableHoverColorChange &&
        css`
          &:hover {
            background-color: ${theme.ds.colors.neutral100};
          }
        `}
      `
    }}
  }
`

export const StyledBodyCell = styled(TableCell)`
  && {
    font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.neutral900};
    padding: 0.75rem 1rem;
    vertical-align: middle;

    &.centered {
      text-align: center;
    }
  }
`

export const StyledFullWidthCell = styled(TableCell)`
  && {
    padding: 1rem;
  }
`

export const StyledEmptyCell = styled(TableCell)`
  && {
    padding: 1rem;
    text-align: start;
    color: ${({ theme }) => theme.ds.colors.textSecondary};
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    font-weight: ${({ theme }) => theme.ds.typography.weight.black};
  }
`
